import React from "react";

function Pricing() {
  const plans = [
    { title: "Swimming Monthly Membership", price: "₹ 3,500" },
    { title: "Swimming 4 Months Membership", price: "₹ 11,500" },
    { title: "Swimming Yearly Membership", price: "₹ 25,000" },
    { title: "Ladies Swimming (3 Months)", price: "₹ 9,000" },
    { title: "Family Membership (2 Persons)", price: "₹ 47,000" },
    { title: "Corporate Membership (2 Persons)", price: "₹ 47,000" },
  ];

  return (
    <section className="plans" id="Pricing">
      <h2>Membership Plans</h2>

      <div className="plan-grid">
        {plans.map((plan, index) => (
          <div className="plan-card" key={index}>
            <h3>{plan.title}</h3>
            <div className="price">{plan.price}</div>

            <a href="tel:+918275055590" className="btn">
              Call for Details
            </a>
          </div>
        ))}
      </div>

      <p className="note">
        Note: Rules and regulations must be followed. Members must be present
        during membership processing.
      </p>
    </section>
  );
}

export default Pricing;